<template>
  <div>
    <p
      v-if="label"
      class="title title--6 half-spacing"
    >
      {{ label }}
      <span
        v-if="showAsOptional"
        class="gray regular smaller"
      >
        (Optional)
      </span>
    </p>

    <div
      v-if="showCustomTip"
      class="center"
    >
      <text-input
        v-model="customTip"
        v-auto-focus
        type="dollars"
        label="Tip Amount"
        name="customTip"
        :allow-negative="false"
      />
      <button
        type="button"
        class="link link--margin primary"
        @click="showCustomTip = false"
      >
        View Tip Selector
      </button>
    </div>

    <div
      v-else
      class="center"
    >
      <div class="layout layout--horizontal">
        <button
          type="button"
          class="button button--icon button--light button--light-text"
          title="Decrease Tip"
          @click="tipDecrease"
        >
          <span class="icon far fa-minus" />
        </button>

        <div>
          <h3 class="title title--2 no-spacing">
            <template v-if="isDollarAmount">{{ $dollars(tipAmount) }}</template>
            <template v-else>Tip {{ tipAmount }}%</template>
          </h3>
          <p>
            <template v-if="isDollarAmount">Tip Amount</template>
            <template v-else>{{ $dollars(value) }}</template>
          </p>
        </div>

        <button
          type="button"
          class="button button--icon button--light button--light-text"
          title="Increase Tip"
          @click="tipIncrease"
        >
          <span class="icon far fa-plus" />
        </button>
      </div>

      <button
        type="button"
        class="link link--margin primary"
        @click="showCustomTip = true"
      >
        Add Custom Tip
      </button>
    </div>
  </div>
</template>



<script>
  export default {
    name: 'TipSelectionButton',

    inject: {
      $validator: {
        from: '$validator'
      },

      validatedForm: {
        from: 'validatedForm',
        default() {
          return {};
        }
      }
    },

    props: {
      label: {
        type: String,
        default: ''
      },

      options: {
        type: Array,
        required: true
      },

      showAsOptional: {
        type: Boolean,
        default: false
      },

      total: {
        type: Number,
        required: true
      },

      value: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        customTip: null,
        showCustomTip: false,
        tipAmount: 0
      };
    },

    computed: {
      defaultOption() {
        return this.options.find(option => option.isDefault) || this.options[0];
      },

      isDollarAmount() {
        return this.defaultOption && Object.prototype.hasOwnProperty.call(this.defaultOption, 'dollarAmount');
      }
    },

    watch: {
      customTip: 'tipSelectHandler',
      showCustomTip: 'tipSelectHandler',
      tipAmount: 'tipSelectHandler',
      isDollarAmount: 'selectDefaultTip',
      total: 'tipSelectHandler'
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.selectDefaultTip();
      },

      selectDefaultTip() {
        if (this.defaultOption) {
          const { dollarAmount, percentAmount } = this.defaultOption;
          this.tipAmount = this.isDollarAmount
            ? dollarAmount || 0
            : percentAmount || 0;
        }
      },

      tipDecrease() {
        if (this.tipAmount > 0) {
          if (this.isDollarAmount) this.tipAmount -= 0.5;
          else this.tipAmount -= 1;
        }
      },

      tipIncrease() {
        if (this.isDollarAmount) this.tipAmount += 0.5;
        else this.tipAmount += 1;
      },

      tipSelectHandler() {
        let tip = 0;

        if (this.showCustomTip) {
          if (this.customTip && this.isDollarAmount) this.tipAmount = this.customTip;
          tip = this.customTip;
        }

        else if (this.tipAmount) {
          if (this.isDollarAmount) {
            tip = this.tipAmount;
          }
          else {
            const percentage = this.tipAmount / 100;
            tip = Math.round((this.total * percentage) * 100) / 100;
          }
        }

        this.$emit('select', tip);
      }
    }
  };
</script>
